import type { JSX, ReactNode } from "react";

import { ErrorState, LoadingState } from "../data/index.js";

export interface BreakdownCardProps {
  title: string;
  subtitle?: string;
  loading?: boolean;
  error?: unknown;
  onRetry?: () => void;
  /** Override the empty-state body (rendered when not loading/error and no children). */
  empty?: boolean;
  emptyMessage?: string;
  children?: ReactNode;
}

export function BreakdownCard({
  title,
  subtitle,
  loading,
  error,
  onRetry,
  empty,
  emptyMessage,
  children,
}: BreakdownCardProps): JSX.Element {
  return (
    <section className="flex flex-col gap-4 rounded-lg border bg-card p-4">
      <header className="flex flex-col gap-0.5">
        <h2 className="text-base font-semibold text-foreground">{title}</h2>
        {subtitle ? (
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        ) : null}
      </header>
      {loading ? (
        <LoadingState variant="skeleton" rows={3} />
      ) : error ? (
        <ErrorState
          error={error}
          title="Failed to load"
          onRetry={onRetry}
          className="p-4"
        />
      ) : empty ? (
        <p className="text-xs text-muted-foreground">
          {emptyMessage ?? "No data yet."}
        </p>
      ) : (
        children
      )}
    </section>
  );
}
